window.addEventListener('load', () => {
	const currentUrl = window.location.href;

	// Add click event listener to elements with class 'card--leader'
	const leaderCards = document.querySelectorAll('.card--leader');
	leaderCards.forEach((card) => {
		card.addEventListener('click', () => {
			sessionStorage.removeItem('currentSection');
		});
	});

	// Check if the URL contains '/leadership/'
	if (currentUrl.includes('/leadership-team/')) {
		sessionStorage.setItem('currentSection', 'leadership-team');
	} else if (currentUrl.includes('/scientific-leadership/')) {
		sessionStorage.setItem('currentSection', 'scientific-leadership');
	}

	// Check if the URL contains '/leadership/' and session storage has 'leadership team'
	if (currentUrl.includes('/leadership/') && sessionStorage.getItem('currentSection') === 'leadership-team') {
		const tablistParent = document.querySelector('.em-tabs__tablist');
		if (tablistParent && tablistParent.children.length > 0) {
			tablistParent.children[0].click();
		}
	} else if (currentUrl.includes('/leadership/') && sessionStorage.getItem('currentSection') === 'scientific-leadership') {
		console.log('scientific leadership');
		const tablistParent = document.querySelector('.em-tabs__tablist');
		if (tablistParent && tablistParent.children.length > 0) {
			tablistParent.children[1].click();
		}
	}
});
